export default __webpack_public_path__ + "static/media/logo-w-1.24f19705.svg";